// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: apps/client/src/assets/builders/*.ts
import * as m0 from './builders/board';
import * as m1 from './builders/bridge';
import * as m2 from './builders/dropbox';
import * as m3 from './builders/fish';
import * as m4 from './builders/fossil';
import * as m5 from './builders/fruit';
import * as m6 from './builders/house';
import * as m7 from './builders/letter';
import * as m8 from './builders/mailbox';
import * as m9 from './builders/rock';
import * as m10 from './builders/rod';
import * as m11 from './builders/shell';
import * as m12 from './builders/shovel';
import * as m13 from './builders/surface';
import * as m14 from './builders/tank';
import * as m15 from './builders/tree';
export const builderModules = [m0, m1, m2, m3, m4, m5, m6, m7, m8, m9, m10, m11, m12, m13, m14, m15] as const;
